export default "/img/icon/attachment.svg"